import { useMutation } from '@tanstack/react-query';
import { MedicalRecordService } from '../medical-record.service';

type PatchMedicalRecordSessionVariables = {
	recordId: string;
	sessionId: string;
	body: MedicalRecords.UpdateMedicalRecordSessionBody;
};

export const usePatchMedicalRecordSession = (
	onSuccess?: (session: MedicalRecords.MedicalRecordSession) => void,
) =>
	useMutation({
		mutationFn: ({
			recordId,
			sessionId,
			body,
		}: PatchMedicalRecordSessionVariables) =>
			MedicalRecordService.patchSession(recordId, sessionId, body),
		onSuccess,
	});

type PatchMedicalRecordAssessmentVariables = {
	recordId: string;
	assessmentId: string;
	body: MedicalRecords.UpdateMedicalRecordAssessmentBody;
};

export const usePatchMedicalRecordAssessment = (
	onSuccess?: (assessment: MedicalRecords.Assessment) => void,
) =>
	useMutation({
		mutationFn: ({
			recordId,
			assessmentId,
			body,
		}: PatchMedicalRecordAssessmentVariables) =>
			MedicalRecordService.patchAssessment(recordId, assessmentId, body),
		onSuccess,
	});

type PatchMedicalRecordPlanVariables = {
	recordId: string;
	planId: string;
	body: MedicalRecords.UpdateMedicalRecordPlanBody;
};

export const usePatchMedicalRecordPlan = (
	onSuccess?: (plan: MedicalRecords.Plan) => void,
) =>
	useMutation({
		mutationFn: ({
			recordId,
			planId,
			body,
		}: PatchMedicalRecordPlanVariables) =>
			MedicalRecordService.patchPlan(recordId, planId, body),
		onSuccess,
	});
